export function getHistoryMaxDate(maxDate?: Date | null, today = new Date()): Date {
  return maxDate && maxDate < today ? maxDate : today;
}
